import { faShieldCheck } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components';
import { useAtomValue } from 'jotai';

import { shouldAllowRecordingAtom } from '../../atoms';

interface ConsentFlowProps {
  onConsentDenied: () => void;
  onStartProviderOnlyRecording: () => void;
  onStartRecording: () => void;
  isPromptSelected: boolean;
  monitoringStream: MediaStream | null;
  mediaBlobUrl?: string;
  isSheetOpen: boolean;
  buttonStyling: string;
  enableVoiceNotesConsent: boolean;
}

export const ConsentFlow = ({
  onConsentDenied,
  onStartProviderOnlyRecording,
  onStartRecording,
  isPromptSelected,
  monitoringStream,
  mediaBlobUrl,
  isSheetOpen,
  buttonStyling,
  enableVoiceNotesConsent,
}: ConsentFlowProps) => {
  const shouldAllowRecording = useAtomValue(shouldAllowRecordingAtom);

  return (
    <div className="vai-flex vai-flex-col vai-items-center">
      {enableVoiceNotesConsent ? (
        <>
          <div className="vai-flex vai-justify-center vai-items-center vai-bg-amber-50 vai-text-amber-600 vai-border vai-border-amber-100 vai-rounded-md vai-px-2 vai-py-1 vai-mb-6 ai-text-sm vai-w-full">
            <p className="vai-text-center">
              Obtain recording consent: <br />
              &quot;
              <span className="vai-font-bold">
                Can we record this visit for note taking only, so we can focus
                on you?&quot;
              </span>
            </p>
          </div>

          <div className="vai-flex vai-flex-row vai-gap-x-3">
            <Button
              onClick={onConsentDenied}
              variant={'sheet'}
              size={isSheetOpen ? 'default' : 'sm'}
            >
              Consent Denied
            </Button>

            <Button
              onClick={onStartProviderOnlyRecording}
              variant={'sheet'}
              size={isSheetOpen ? 'default' : 'sm'}
              disabled={
                !isPromptSelected || !monitoringStream || !shouldAllowRecording
              }
            >
              Provider Only Recording
            </Button>

            <Button
              onClick={onStartRecording}
              variant={mediaBlobUrl ? 'sheet' : 'default'}
              className={`${buttonStyling} hover:vai-ring-primary/50`}
              size={isSheetOpen ? 'default' : 'sm'}
              disabled={
                !isPromptSelected || !monitoringStream || !shouldAllowRecording
              }
            >
              {!monitoringStream
                ? 'Select Microphone First'
                : `Yes, Start Recording`}
            </Button>
          </div>
        </>
      ) : (
        <Button
          onClick={onStartRecording}
          variant={mediaBlobUrl ? 'sheet' : 'default'}
          className={`${buttonStyling} hover:vai-ring-primary/50`}
          size={isSheetOpen ? 'default' : 'sm'}
          disabled={
            !isPromptSelected || !monitoringStream || !shouldAllowRecording
          }
        >
          {!monitoringStream ? 'Select Microphone First' : `Start Recording`}
        </Button>
      )}
    </div>
  );
};
